/**
 * Theme Name: project-sscms v1.514.0
 * Theme URI: git+https://github.com/1debit/project-sscms.git
 * Author: Sharp Notions, LLC
 * Author URI: https://sharpnotions.com
 * Description: Wordpress theme for Chime (project-sscms) [main - 884050627]
 * Version: 1.514.0-2025-07-24T18-59-01
 * License: ISC
 * License URI: "http://www.gnu.org/licenses/gpl-2.0.html"
 */
/**
 * File manifest-money.js.
 * Handles logic for the Manifest Money template.
 */

const mmSlider = document.querySelector('.manifest-money__slides');
const mmArrowPrev = document.querySelector('.manifest-money__slider-arrow--prev');
const mmArrowNext = document.querySelector('.manifest-money__slider-arrow--next');

function manifestSlider($) {
  $(mmSlider).slick({
    infinite: false,
    fade: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: false,
    variableWidth: true,
    autoplay: false,
    pauseOnDotsHover: true,
    lazyLoad: 'anticipated',
    prevArrow: mmArrowPrev,
    nextArrow: mmArrowNext
  });
}

// Inits
if (typeof jQuery !== 'undefined') jQuery(document).ready(function ($) {
  manifestSlider($);
});
